import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changePrice: (value: Nullable<number>) => void;
	disabled: boolean;
}

export const PriceInput: React.FC<IProps> = React.memo(({ changePrice, disabled }) => (
	<FormInput
		testId="PriceInput"
		name="price"
		label="signedPriceLabel"
		min={0}
		precision={0}
		onChangeNumber={changePrice}
		type="number"
		disabled={disabled}
	/>
));
